import { Icon } from '@capsico/ui';
import { useCopy } from '../hooks/useCopy';

/**
 * Support code chip (W25): "Share this code with support" + the `CAP-XXXXXX` code in a mono chip
 * that copies on tap. Presentation only — callers pass the code and the translated labels.
 */
export function SupportRef({
  code,
  label,
  copyLabel,
  copiedLabel,
  onDark = false,
  start = false,
}: {
  code: string;
  label: string;
  copyLabel: string;
  copiedLabel: string;
  /** On a dark or coloured surface (toasts). */
  onDark?: boolean;
  /** Left-align (inside left-aligned surfaces); centred by default. */
  start?: boolean;
}) {
  const { copied, copy } = useCopy();
  return (
    <div
      className={`pointer-events-auto flex flex-wrap items-center gap-2 ${start ? 'justify-start' : 'justify-center'} text-xs ${onDark ? 'text-inherit' : 'text-ink-2'}`}
    >
      <span>{label}</span>
      <button
        type="button"
        onClick={() => copy(code)}
        aria-label={`${copyLabel} ${code}`}
        className={`inline-flex items-center gap-1.5 rounded-control px-2 py-1 font-mono text-xs font-semibold tracking-wide ${onDark ? 'bg-white/15 text-inherit' : 'border border-line bg-surface-2 text-ink'}`}
      >
        {code}
        <Icon name={copied ? 'check' : 'copy'} size={14} />
      </button>
      <span className="sr-only" aria-live="polite">
        {copied ? copiedLabel : ''}
      </span>
    </div>
  );
}
